import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import config from '../../config';
import { useSelector } from 'react-redux';

const cards = [
  {
    title: 'oncologist',
    image:
      'https://visit-public.s3.ap-south-1.amazonaws.com/assets/easiestexam/book-onco.png',
  },
  {
    title: 'mammo',
    image:
      'https://visit-public.s3.ap-south-1.amazonaws.com/assets/easiestexam/book-mammo.png',
  },
  {
    title: 'expert',
    image:
      'https://visit-public.s3.ap-south-1.amazonaws.com/assets/easiestexam/disha-cancer.png',
  },
  {
    title: 'bff',
    image:
      'https://visit-public.s3.ap-south-1.amazonaws.com/assets/easiestexam/nominate-easiestexam.png',
  },
];
const OuterContainer = styled.div`
  position: relative;
  width: calc(100% - 15px);
  background: #eee;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 10;
  cursor: pointer;
  width: 90%;
  min-width: 157px;
  overflow: hidden;
  margin: 0 10px;
  cursor: pointer;
  &:active {
    opacity: 0.2;
  }
`;

const AdditionalCards = () => {
  const history = useHistory();
  const user = useSelector((state) => state.user);
  function handleClick(title) {
    switch (title) {
      case 'expert':
        const { userName, userEmail, userPhone } = user;
        let url = 'https://easiestexam.tatvacare.in';
        // if (userName) url += '?username=' + userName;
        // if (userEmail) url += '&useremail=' + userEmail;
        // if (userPhone) url += '&userphone=' + userPhone;
        window.open(url, '_blank');
        break;
      case 'mammo':
        history.push('/lab-test/universal-ahc');
        break;
      case 'oncologist':
        history.push('/consultation/doctor-select', {
          searchType: 'treat',
          verticalId: config?.oncologistVerticalId,
          searchText: 'Oncologist',
          specialistSearch: true,
          // showSearchOverlay: true,
        });
        break;
      case 'bff':
        window.open(
          'https://form.typeform.com/to/GKepNy43?typeform-source=easiestexam.com',
          '_blank'
        );
        break;
      default:
        history.push('/home');
        break;
    }
  }
  return (
    <div className="gridContainer mt-20">
      {cards.map((card) => (
        <OuterContainer onClick={() => handleClick(card.title)}>
          <img src={card.image} alt="" className="" />
        </OuterContainer>
      ))}
    </div>
  );
};

export default AdditionalCards;
